export default __webpack_public_path__ + "static/media/Satisfied.6076036a.svg";